import React from 'react';
import { Link } from 'react-router-dom';
import { Twitter, Linkedin, Github, ArrowRight, Instagram } from 'lucide-react';

function Footer() {
    return (
        <footer className="site-footer">
            <div className="container" style={{ paddingBottom: 'var(--spacing-2xl)' }}>
                <div className="grid" style={{ gridTemplateColumns: 'repeat(auto-fit, minmax(200px, 1fr))', gap: 'var(--spacing-xl)' }}>

                    <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--spacing-md)' }}>
                        <Link to="/" className="flex items-center gap-xs text-on-dark" style={{ textDecoration: 'none' }}>
                            <div style={{
                                background: 'var(--gradient-brand)',
                                color: 'var(--color-text-on-primary)',
                                width: '32px',
                                height: '32px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                borderRadius: '8px',
                                fontWeight: 800,
                                fontSize: '1.2rem',
                            }}>L</div>
                            <span style={{ fontWeight: 800, fontSize: '1.4rem', letterSpacing: '-0.5px' }}>Learnly</span>
                        </Link>
                        <p style={{ fontSize: '0.95rem', lineHeight: 1.6, opacity: 0.8 }}>
                            Empowering academies and teams with intelligent, scalable learning solutions. Built for the future of education.
                        </p>
                        <div className="flex gap-sm" style={{ marginTop: 'var(--spacing-sm)' }}>
                            <a href="#" className="site-footer-social hover:text-primary transition-fast" aria-label="Twitter"><Twitter size={20} /></a>
                            <a href="#" className="site-footer-social hover:text-primary transition-fast" aria-label="LinkedIn"><Linkedin size={20} /></a>
                            <a href="#" className="site-footer-social hover:text-primary transition-fast" aria-label="GitHub"><Github size={20} /></a>
                            <a href="#" className="site-footer-social hover:text-primary transition-fast" aria-label="Instagram"><Instagram size={20} /></a>
                        </div>
                    </div>

                    <div>
                        <h4 className="site-footer-heading">Product</h4>
                        <ul className="flex flex-col gap-sm" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li><Link to="/features" className="site-footer-link">Features</Link></li>
                            <li><Link to="/pricing" className="site-footer-link">Pricing</Link></li>
                            <li><Link to="/integrations" className="site-footer-link">Integrations</Link></li>
                            <li><Link to="/changelog" className="site-footer-link">Changelog <span className="site-footer-badge">New</span></Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="site-footer-heading">Use Cases</h4>
                        <ul className="flex flex-col gap-sm" style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                            <li><Link to="/" className="site-footer-link">Corporate Training</Link></li>
                            <li><Link to="/" className="site-footer-link">Bootcamps</Link></li>
                            <li><Link to="/" className="site-footer-link">Customer Onboarding</Link></li>
                            <li><Link to="/" className="site-footer-link">Compliance</Link></li>
                        </ul>
                    </div>

                    <div>
                        <h4 className="site-footer-heading">Stay up to date</h4>
                        <p className="text-on-dark-muted" style={{ fontSize: '0.9rem', marginBottom: 'var(--spacing-md)' }}>
                            Get the latest updates and educational resources directly in your inbox.
                        </p>
                        <form className="flex gap-xs" onSubmit={(e) => e.preventDefault()}>
                            <input
                                type="email"
                                placeholder="Enter your email"
                                className="site-footer-input"
                            />
                            <button type="submit" className="btn btn-primary hover:opacity-90 transition-fast" style={{ padding: '10px' }}>
                                <ArrowRight size={20} />
                            </button>
                        </form>
                    </div>
                </div>
            </div>

            <div className="site-footer-bar">
                <div className="container flex flex-col md:flex-row justify-between items-center gap-md text-center md:text-left site-footer-bar-text">
                    <p>© 2026 Learnly Inc. All rights reserved.</p>
                    <div className="flex gap-md justify-center">
                        <Link to="/terms" className="site-footer-link">Terms of Service</Link>
                        <Link to="/privacy" className="site-footer-link">Privacy Policy</Link>
                        <Link to="/cookies" className="site-footer-link">Cookie Settings</Link>
                    </div>
                </div>
            </div>
        </footer>
    );
}

export default Footer;
